var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.board ? _c('div', [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _c('div', {
    staticClass: "pa-12px py-md-14px grey lighten-4"
  }, [_c('strong', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.board.subject))])]), _c('v-divider'), _c('div', {
    staticClass: "pa-12px py-md-14px"
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_c('strong', {
    staticClass: "font-weight-medium"
  }, [_vm._v("작성일자 : ")]), _vm._v(_vm._s(_vm.$dayjs(_vm.board.createdAt).format("YYYY-MM-DD HH:mm:ss")))])]), _c('v-divider'), _c('div', {
    staticClass: "font-size-14 font-size-md-16 pa-12px py-20px min-h-200px"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.board.content)
    }
  })]), _c('v-divider'), _vm.board.isComment ? _c('div', [_vm._m(0), !_vm.$vuetify.breakpoint.mobile ? _c('div', [_c('v-data-table', {
    staticClass: "v-data-table--default",
    attrs: {
      "headers": _vm.commentHeaders,
      "items": _vm.comments,
      "disable-sort": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function fn(_ref) {
        var item = _ref.item;
        return _c('span', {}, [_vm._v(_vm._s((_vm.page - 1) * _vm.limit + +_vm.comments.indexOf(item) + 1))]);
      }
    }, {
      key: "item.writer",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(_vm._s(item.writer.username))];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(_vm._s(_vm.$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")))];
      }
    }, {
      key: "item.content",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "11"
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.getDisplayedContent(item))
          }
        })]), _c('v-spacer'), item.content.length > _vm.maxContentLength ? _c('v-col', [!item.show ? _c('v-icon', {
          on: {
            "click": function click($event) {
              item.show = true;
            }
          }
        }, [_vm._v("mdi-chevron-down")]) : _c('v-icon', {
          on: {
            "click": function click($event) {
              item.show = false;
            }
          }
        }, [_vm._v("mdi-chevron-up")])], 1) : _vm._e()], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var _vm$payload, _vm$payload2;

        var item = _ref5.item;
        return [_c('div', {
          staticClass: "v-btn--group--x-small"
        }, [item._member == ((_vm$payload = _vm.payload) === null || _vm$payload === void 0 ? void 0 : _vm$payload._user) ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "color": "secondary"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("수정")]) : _vm._e(), item._member == ((_vm$payload2 = _vm.payload) === null || _vm$payload2 === void 0 ? void 0 : _vm$payload2._user) ? _c('v-btn', {
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "grey"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_c('span', {
          staticClass: "grey--text text--darken-3"
        }, [_vm._v("삭제")])]) : _vm._e()], 1)];
      }
    }], null, false, 3767831936)
  })], 1) : _c('div', [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _vm._l(_vm.comments, function (comment, index) {
    var _vm$payload3;

    return [index ? _c('v-divider', {
      key: "divider".concat(comment._id),
      staticClass: "grey lighten-1"
    }) : _vm._e(), _c('div', {
      key: "title".concat(comment._id),
      staticClass: "pa-12px py-md-14px"
    }, [_c('v-row', {
      staticClass: "font-size-14 font-size-md-16",
      attrs: {
        "no-gutters": "",
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', [_vm._v(_vm._s(comment.writer.username))])]), _c('v-col', {
      staticClass: "d-flex",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-divider', {
      staticClass: "grey lighten-1 mx-8px",
      staticStyle: {
        "height": "12px"
      },
      attrs: {
        "vertical": ""
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$dayjs(comment.createdAt).format("YYYY-MM-DD")))])])], 1)], 1), _c('div', {
      key: "content".concat(comment._id),
      staticClass: "pa-12px py-md-14px grey lighten-4"
    }, [_c('span', {
      staticClass: "font-size-14 font-size-md-16"
    }, [_vm._v(_vm._s(comment.content))]), comment._member == ((_vm$payload3 = _vm.payload) === null || _vm$payload3 === void 0 ? void 0 : _vm$payload3._user) ? _c('div', {
      staticClass: "mt-10px"
    }, [_c('div', {
      staticClass: "v-btn--group--x-small"
    }, [_c('v-btn', {
      attrs: {
        "x-small": "",
        "color": "secondary"
      },
      on: {
        "click": function click($event) {
          return _vm.edit(comment);
        }
      }
    }, [_vm._v("수정")]), _c('v-btn', {
      staticClass: "white",
      staticStyle: {
        "border-color": "#9e9e9e!important"
      },
      attrs: {
        "x-small": "",
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.remove(comment);
        }
      }
    }, [_c('span', {
      staticClass: "grey--text text--darken-3"
    }, [_vm._v("삭제")])])], 1)]) : _vm._e()])];
  }), _c('v-divider', {
    staticClass: "grey lighten-1"
  })], 2), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": _vm.search
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1), _c('div', {
    staticClass: "mt-20px mt-md-30px"
  }, [_c('div', {
    staticClass: "pa-12px py-md-14px grey lighten-4"
  }, [_c('div', {
    staticClass: "mt-10px"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "white",
    attrs: {
      "placeholder": "댓글을 남겨주세요.",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.comment.content,
      callback: function callback($$v) {
        _vm.$set(_vm.comment, "content", $$v);
      },
      expression: "comment.content"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "v-btn--input",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("댓글 등록")])], 1)], 1)], 1)])]), _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog v-card--dialog--sm"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("댓글")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('div', [_c('v-textarea', {
    attrs: {
      "placeholder": "기대평을 입력해주세요",
      "persistent-placeholder": "",
      "outlined": "",
      "hide-details": "",
      "rows": "8"
    },
    model: {
      value: _vm.comment.content,
      callback: function callback($$v) {
        _vm.$set(_vm.comment, "content", $$v);
      },
      expression: "comment.content"
    }
  })], 1)]), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save2
    }
  }, [_vm._v("등록")])], 1)], 1)], 1)])], 1)], 1) : _vm._e(), _c('login-dialog', {
    ref: "loginDialog"
  })], 1) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tit-wrap mb-10px mb-md-20px mt-4"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("댓글")])]);
}]

export { render, staticRenderFns }